import { render, staticRenderFns } from "./vendorCouncilTab.vue?vue&type=template&id=7e971c0d"
import script from "./vendorCouncilTab.vue?vue&type=script&lang=js"
export * from "./vendorCouncilTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e971c0d')) {
      api.createRecord('7e971c0d', component.options)
    } else {
      api.reload('7e971c0d', component.options)
    }
    module.hot.accept("./vendorCouncilTab.vue?vue&type=template&id=7e971c0d", function () {
      api.rerender('7e971c0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/csm/vendorCouncilTab.vue"
export default component.exports